var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import onePlatformGetServicesAvailable from './onePlatformGetServicesAvailable';
import onePlatformGetProductOffering from './onePlatformGetProductOffering';
import onePlatformQuoteCreate from './onePlatformQuoteCreate';
import onePlatformQuoteUpdate from './onePlatformQuoteUpdate';
import AppState from '../../AppState';
import onePlatformSystemError from "./onePlatformSystemError";
import { ActiveServiceCodes } from "../../models/enums";
import onePlatformAlreadyActiveService from "./onePlatformAlreadyActiveService";
import checkServicesAvailable from '../checkServicesAvailable';
import { getEstablishedServiceQualification } from '../getServiceQualification';
/**
 * Fetches service qualification data from a given endpoint using One Platform authentication.
 *
 * @param {string} endpoint - The URL endpoint to fetch the service qualification data from.
 * @param {string} clientId - The client ID for One Platform authentication.
 * @param {string} clientSecret - The client secret for One Platform authentication.
 * @param {string} onePlatformSqData - The service qualification data to send in the request body.
 * @returns {Promise<Object>} - A promise that resolves to the parsed JSON response from the endpoint.
 */
const _fetchServiceQualification = (endpoint, clientId, clientSecret, onePlatformSqData) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(endpoint, {
        method: 'post',
        headers: {
            'client_id': clientId,
            'client_secret': clientSecret,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: onePlatformSqData,
    });
    if (!response.ok) {
        onePlatformSystemError();
    }
    return response.json();
});
/**
 * Get Full Fibre plans from the One Platform Service Qualification API.
 *
 * @param {Object} serviceAddressObject
 *   The address object returned by the address search.
 */
const onePlatformGetServiceQualification = (serviceAddressObject) => __awaiter(void 0, void 0, void 0, function* () {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const onePlatformData = AppState.get('onePlatformData');
    const { settings, context } = drupalJsObjects;
    const { onePlatformApiRoot, onePlatformApiClientId, onePlatformApiClientSecret, onePlatformApiSq, token } = settings;
    const onePlatformSqEndpoint = onePlatformApiRoot + onePlatformApiSq;
    onePlatformData.externalId = '123234';
    onePlatformData.serviceQualificationItem[0].service.place[0].id = serviceAddressObject.locId;
    const onePlatformSqData = JSON.stringify(onePlatformData);
    try {
        const onePlatformServiceQualificationObject = yield _fetchServiceQualification(onePlatformSqEndpoint, onePlatformApiClientId, onePlatformApiClientSecret, onePlatformSqData);
        if (onePlatformServiceQualificationObject) {
            if (onePlatformServiceQualificationObject.qualificationResult == 'unqualified') {
                const addressConfirmed = AppState.get('addressConfirmed');
                const gnafId = addressConfirmed.getAttribute('data-address-id');
                const result = yield getEstablishedServiceQualification(gnafId);
                const addressCheckProgress = context.querySelector('#address-check-progress');
                if (typeof result === 'object') {
                    const { serviceQualification, address, salesId, token } = result;
                    AppState.set('salesId', salesId);
                    AppState.set('token', token);
                    AppState.set('addressCheckProgress', addressCheckProgress);
                    checkServicesAvailable(serviceQualification, address);
                }
            }
            else if (checkActiveServiceStatus(onePlatformServiceQualificationObject.qualificationResult)) {
                onePlatformAlreadyActiveService();
            }
            else {
                const productOffering = yield onePlatformGetProductOffering();
                if (productOffering.length > 0) {
                    const quote = yield onePlatformQuoteCreate(onePlatformServiceQualificationObject, productOffering, token);
                    if (quote) {
                        const selectedPlanEl = context.querySelector('#service-selected');
                        const actionObjectId = selectedPlanEl.getAttribute('data-plan-one-platform-id');
                        const quoteUpdated = yield onePlatformQuoteUpdate(quote, productOffering, actionObjectId, false);
                        if (typeof quoteUpdated === 'object') {
                            yield onePlatformGetServicesAvailable(onePlatformServiceQualificationObject, quoteUpdated, productOffering, actionObjectId);
                        }
                    }
                }
            }
        }
    }
    catch (error) {
        console.error('Error receiving SQ.');
    }
});
export const checkActiveServiceStatus = (qualificationResult) => {
    return Object.values(ActiveServiceCodes).includes(qualificationResult);
};
export default onePlatformGetServiceQualification;
